import { render, staticRenderFns } from "./ProductCheckLeader.vue?vue&type=template&id=3b527211&scoped=true"
import script from "./ProductCheckLeader.vue?vue&type=script&lang=js"
export * from "./ProductCheckLeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b527211",
  null
  
)

export default component.exports